import { Card, IconButton, Tooltip, Zoom } from "@material-ui/core";
import keyBy from "lodash/keyBy";
import * as React from "react";
import { Datagrid, FunctionField, ListContextProvider, TextField, useNotify } from "react-admin";
import { CustomDateField } from "../../../../../Components/CustomDateField";
import CreatedByField from "../../../../../Components/ReferenceFields/CreatedBy/CreatedByField";
import UpdatedByField from "../../../../../Components/ReferenceFields/UpdatedBy/UpdatedByField";
import { useAppDataProvider } from "../../../../../dataprovider";
import CancelIcon from "@material-ui/icons/Cancel";

export const RequestSptList = props => {
  const dataProvider = useAppDataProvider();
  const notify = useNotify();

  const excludeButtonClick = (record: any) => e => {
    record.isExcluded = false;
    dataProvider.updateRequestSpt(record).then(result => {
      notify(`Record updated`, "success", false, true);
      getSptList();
    });
  };

  const getSptList = () => {
    dataProvider
      .getList("requestSpts", {
        pagination: { page: 1, perPage: 9999 },
        sort: { field: "id", order: "ASC" },
        filter: { requestId__eq: props?.requestId },
      })
      .then(response => {
        let data: any = response.data;
        if (data.length > 0) {
          props.requestSpt = data;
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  return (
    <Card>
      <ListContextProvider
        value={{
          data: keyBy(props?.requestSpt || [], "id"),
          ids: props?.requestSpt?.map?.(({ id }) => id) || [],
          currentSort: { field: "id", order: "ASC" },
        }}
      >
        <Datagrid {...props} optimized hasBulkActions={false} rowClick={false}>
          <FunctionField
            style={{ fontSize: 12 }}
            label={"Exclude"}
            render={(record: any) => (
              <IconButton onClick={excludeButtonClick(record)} color="primary" disabled={record?.isExcluded === false}>
                <Tooltip TransitionComponent={Zoom} title="Cancel Exclude">
                  <CancelIcon />
                </Tooltip>
              </IconButton>
            )}
          />
          <TextField source="spt" label="Spt" />
          <TextField
            style={{
              width: "100%",
              whiteSpace: "pre-wrap",
              lineBreak: "anywhere",
            }}
            aria-multiline="true"
            component="pre"
            source="remarks"
            label="Remarks"
          />
          <CreatedByField label="CREATED BY" link={false} />
          <CustomDateField source="createdDate" label="CREATED DATE" />
          <UpdatedByField label="Updated By" link={false} />
          <CustomDateField source="updatedDate" label="UPDATED DATE" />
        </Datagrid>
      </ListContextProvider>
    </Card>
  );
};

export default RequestSptList;
